/* ALPHA&OMEGA — icon header: nav drawer (drill-down) + search overlay */
(function () {
  'use strict';
  var body = document.body;
  var nav = document.querySelector('[data-nav]');
  var navOverlay = document.querySelector('[data-nav-overlay]');
  var search = document.querySelector('[data-search-overlay]');

  function lock() { body.classList.add('is-locked'); }
  function unlock() { if (!isNavOpen() && !isSearchOpen()) body.classList.remove('is-locked'); }
  function isNavOpen() { return nav && nav.classList.contains('is-open'); }
  function isSearchOpen() { return search && search.classList.contains('is-open'); }

  /* ---------- Nav drawer ---------- */
  function openNav() {
    if (!nav) return;
    nav.classList.add('is-open'); navOverlay.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false'); lock();
  }
  function closeNav() {
    if (!nav) return;
    nav.classList.remove('is-open'); navOverlay.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true'); unlock();
    setTimeout(resetPanels, 320);
  }
  function resetPanels() {
    nav.querySelectorAll('.navd__panel').forEach(function (p) {
      p.classList.remove('is-active', 'is-left');
      if (p.dataset.panel === 'root') p.classList.add('is-active');
    });
  }
  function showPanel(id) {
    var panels = nav.querySelectorAll('.navd__panel');
    panels.forEach(function (p) {
      if (p.dataset.panel === id) { p.classList.add('is-active'); p.classList.remove('is-left'); }
      else if (p.classList.contains('is-active')) { p.classList.remove('is-active'); p.classList.add('is-left'); }
      else { p.classList.remove('is-active', 'is-left'); }
    });
    var target = nav.querySelector('[data-panel=' + id + ']');
    if (target) target.scrollTop = 0;
  }

  /* ---------- Search overlay ---------- */
  function openSearch() {
    if (!search) return;
    search.classList.add('is-open'); search.setAttribute('aria-hidden', 'false'); lock();
    var input = search.querySelector('[data-search-input]');
    setTimeout(function () { if (input) input.focus(); }, 120);
  }
  function closeSearch() {
    if (!search) return;
    search.classList.remove('is-open'); search.setAttribute('aria-hidden', 'true'); unlock();
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-nav]')) { e.preventDefault(); openNav(); return; }
    if (e.target.closest('[data-close-nav]') || e.target.closest('[data-nav-overlay]')) { closeNav(); return; }
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('[data-close-search]')) { closeSearch(); return; }

    var at = e.target.closest('[data-open-nav-at]');
    if (at) { e.preventDefault(); openNav(); showPanel(at.dataset.openNavAt); return; }
    var drill = e.target.closest('[data-drill]');
    if (drill) { showPanel(drill.dataset.drill); return; }
    var back = e.target.closest('[data-back]');
    if (back) { showPanel(back.dataset.back); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeNav(); closeSearch(); }
  });
})();
